
import { ApiService } from '..';

export const MeService = {
    get() {
        return ApiService.get('me');
    },

    post(data) {
        return ApiService.postBase(data);
    },
};